import React, {Component} from 'react';
import {
  Typography,
  SignUpButton,
  Video,
  Header,
  BodyText,
  SectionFade,
  Fade,
  FadeUp,
  Pagination,
  PaginationDots,
  BodyContents,
  SwipeLottie,
  AwairLogo,
} from '../components';

class MovieContainer extends Component {
  render() {
    const {onSignUp, onSelect, isSelected, contents, commonContents, direction, OS} = this.props;
    const {header, body, next} = contents;
    const {background, timeout} = commonContents;

    const onExited = () => {
      if (direction === 'next') onSelect(next);
    };

    return (
      <SectionFade active={isSelected} timeout={timeout.page} timing={500} onExited={onExited}>
        <Video src={background.video} poster={background.poster}/>
        <Header OS={OS}>
          <AwairLogo/>
          <SignUpButton onClick={onSignUp}>
            {header.signUp}
          </SignUpButton>
        </Header>
        <BodyText>
          <FadeUp timeout={timeout.header} timing={500} active={isSelected}>
            <Typography size={'big'} thin>
              {body.header}
            </Typography>
          </FadeUp>
        </BodyText>
        <BodyContents>
          <FadeUp timeout={timeout.header} timing={500} active={isSelected} >
            <Typography size={'small'} bold styles={{margin: '6.5px auto'}}>
              {body.learn}
            </Typography>
            <SwipeLottie/>
          </FadeUp>
        </BodyContents>
        <Pagination>
          <Fade active={isSelected} timeout={timeout.header} timing={500}>
            <PaginationDots length={5} current={0}/>
          </Fade>
        </Pagination>
      </SectionFade>
    );
  }
}

export default MovieContainer;


// WEBPACK FOOTER //
// ./src/app/intro/containers/MovieContainer.js